/* eslint-disable no-unused-vars */
import { ECONTRACT_STATUS, EPARTY_STATUS } from "../../../enums";
import {
  EContractType,
  ESenderRole,
  ETrasactionsType,
  IContractDetailsResponseData,
} from "../../../setup/api/services/contract/models";
import { Menu, MenuItem, IconButton, Badge, AlertColor } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {
  ACTION_ADMIN_CLOSE_REFUND_CUSTOMER,
  ACTION_ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER,
  ACTION_ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER,
  ACTION_ADMIN_CONFIRM_DELIVERY,
  ACTION_ADMIN_DELETE_CONTRACT,
  ACTION_ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER,
  ACTION_ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER,
} from "./constants";
import { ConfirmContractForm } from "./forms/confirmContractActionForm";
import { CONFIRM } from "../../authentication/constants";
import { useCallback, useEffect, useState } from "react";
import {
  ACTION_UNDER_PROCESSING,
  CANNOT_MAKE_THIS_CALL,
  CONFIRMATION_MODAL_DESCRIPTION,
  CONFIRMATION_MODAL_TITLE,
} from "../constants";
import { EContractActions } from "../../../setup/api/services/contractActions/enum";
import {
  IContractActionRequestBody,
  IContractActionResponse,
} from "../../../setup/api/services/contractActions/models";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { doAction } from "../../../setup/api/services/contractActions";
import CustomizedSnackbars from "../../../components/customizedSnackbars";
import { DialogModal } from "../../../components/common/dialog";
import {
  CLOSE_WAITING_FOR_DELIVERY,
  CONFIRM_DELIVERY,
  CONFIRM_INSPECTION,
  RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION,
} from "../../../components/contractListItem/constants";
import React from "react";

import { ResolveState, ampli } from "../../../ampli";
import {
  ICashoutRequest,
  ICashoutResponse,
} from "../../../setup/api/services/payment/models";
import {
  checkCashoutPayment,
  makeCashOutPayment,
  revertTransaction,
  settleTabbyPayment,
} from "../../../setup/api/services/payment";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../components/common/PrimaryButton";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { ButtonType } from "../../../components/common/button";

interface IProps {
  contract: IContractDetailsResponseData;
  isMenuOpen?: boolean;
  handleMenuClose?: () => void;
  anchorEl?: null | HTMLElement;
  feedBack?: () => void;
  receiverType?: ESenderRole;
  id: string;
}
const ContractActions = (props: IProps) => {
  const {
    contract,
    id,
    anchorEl,
    isMenuOpen,
    handleMenuClose,
    feedBack,
    receiverType,
  } = props;
  const userId = AuthConfig.getUserInfo().id;
  const { t } = useTranslation();
  const [snackBarOpen, setSnackBarOpen] = useState<boolean>(false);
  const [snackBarColor, setSnackBarColor] = useState<AlertColor>();
  const [snackBarTitle, setSnackBarTitle] = useState<string>("");
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [withReferenceInput, setWithReferenceInput] = useState<boolean>(false);
  const [isCashoutPending, setIsCashoutPending] = useState<boolean>(false);
  const [currentAction, setCurrentAction] = useState<{
    action: EContractActions;
    description: string;
  }>();

  const isMilestoneContract =
    contract?.type === EContractType.MILESTONE_CONTRACT;

  const clearStates = () => {
    setCurrentAction(undefined);
    setSnackBarOpen(false);
    setModalOpen(false);
    setWithReferenceInput(false);
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const onApproveDeliveryClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.approveDelivery);
    setWithReferenceInput(false);
  };
  const onDeleteContractClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.deleteContract);
    setWithReferenceInput(false);
  };
  const onResolveRefundBuyerClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.resolveRefundBuyer);
    setWithReferenceInput(false);
  };
  const onResolveReleaseSellerClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.resolveReleaseSeller);
    setWithReferenceInput(false);
  };
  const onCloseRefundBuyerClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.closeRefundBuyer);
    setWithReferenceInput(true);
  };
  const onCloseReleaseSellerClick = () => {
    if (!isCashoutPending) {
      toggleModal();
      setCurrentAction(actionsMap.closeReleaseSeller);
      setWithReferenceInput(true);
    }
  };
  const onCompleteClick = () => {
    if (!isCashoutPending) {
      toggleModal();
      setCurrentAction(actionsMap.complete);
      setWithReferenceInput(true);
    }
  };
  const onSettleClick = () => {
    toggleModal();
    setWithReferenceInput(true);
    setCurrentAction(actionsMap.settle);
  };

  const onAcceptInspection = () => {
    toggleModal();
    setCurrentAction(actionsMap.acceptInspection);
  };
  const actionsMap = {
    settle: {
      action: EContractActions.ADMIN_SETTLE_TRANSACTION,
      description: "",
    },
    approveDelivery: {
      action: EContractActions.ADMIN_CONFIRM_DELIVERY,
      description: CONFIRMATION_MODAL_DESCRIPTION.APPROVE_DELIVERY,
    },
    resolveRefundBuyer: {
      action: EContractActions.ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER,
      description:
        CONFIRMATION_MODAL_DESCRIPTION.ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER,
    },
    resolveReleaseSeller: {
      action: EContractActions.ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER,
      description:
        CONFIRMATION_MODAL_DESCRIPTION.ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER,
    },
    closeRefundBuyer: {
      action: EContractActions.ADMIN_CLOSE_REFUND_CUSTOMER,
      description: CONFIRMATION_MODAL_DESCRIPTION.ADMIN_CLOSE_REFUND_CUSTOMER,
    },
    closeReleaseSeller: {
      action: EContractActions.ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER,
      description:
        CONFIRMATION_MODAL_DESCRIPTION.ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER,
    },
    complete: {
      action: EContractActions.ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER,
      description:
        CONFIRMATION_MODAL_DESCRIPTION.ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER,
    },
    acceptInspection: {
      action: EContractActions.ADMIN_ACCEPT_ITEM,
      description: CONFIRMATION_MODAL_DESCRIPTION.ADMIN_ACCEPT_ITEM,
    },
    deleteContract: {
      title: CONFIRMATION_MODAL_TITLE.ADMIN_DELETE_ITEM,
      action: EContractActions.ADMIN_DELETE_CONTRACT,
      description: CONFIRMATION_MODAL_DESCRIPTION.ADMIN_DELETE_ITEM,
    },
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const sendResolveEscalationEvent = (
    currentAction: EContractActions,
    buyerId: string,
    contractId: string,
    sellerId: string
  ) => {
    if (
      currentAction ===
        EContractActions.ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER ||
      currentAction ===
        EContractActions.ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER
    ) {
      let resolveState = ResolveState.Refund;
      if (
        currentAction ===
        EContractActions.ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER
      ) {
        resolveState = ResolveState.Release;
      }
      const properties = {
        adminResolveDate: String(new Date()),
        buyerId: buyerId,
        contractId: contractId,
        resolveState: resolveState,
        sellerId: sellerId,
      };
      try {
        ampli && ampli.adminResolveEscalation(properties);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const sendRefundReleaseEvent = (
    currentAction: EContractActions,
    buyerId: string,
    contractId: string,
    sellerId: string
  ) => {
    if (
      currentAction === EContractActions.ADMIN_CLOSE_REFUND_CUSTOMER ||
      currentAction === EContractActions.ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER
    ) {
      const properties = {
        adminRefundDate: String(new Date()),
        buyerId: buyerId,
        contractId: contractId,
        sellerId: sellerId,
      };
      try {
        if (currentAction === EContractActions.ADMIN_CLOSE_REFUND_CUSTOMER)
          ampli.adminRefundBuyer(properties);
        if (
          currentAction ===
          EContractActions.ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER
        )
          ampli.adminReleaseSeller(properties);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const doContractAction = async (res?: IContractActionResponse) => {
    if (res && res?.sent == true) {
      setSnackBarStates(ACTION_UNDER_PROCESSING, "success");
    } else {
      setSnackBarStates(CANNOT_MAKE_THIS_CALL, "error");
    }
    clearStates();
    handleMenuClose?.();
    feedBack?.();
  };

  const acceptPayment = useCallback(async () => {
    try {
      const body = {
        contractId: contract?.id,
        userId: userId,
        actorRole: ESenderRole.ADMIN,
        receiverId: String(contract?.receiverId),
        senderId: String(contract?.senderId),
        contractAction: EContractActions.ADMIN_VERIFY_PAYMENT,
      };
      await doAction(body);
      setSnackBarStates(ACTION_UNDER_PROCESSING, "success");
      window.location.reload();
    } catch (error) {
      setSnackBarStates(`${CANNOT_MAKE_THIS_CALL} ${error}`, "error");
      console.log("error", error);
    }
  }, [contract?.id, contract?.receiverId, contract?.senderId, userId]);

  const rejectPayment = useCallback(async () => {
    try {
      const body = {
        contractId: contract?.id,
        userId: userId,
        actorRole: ESenderRole.ADMIN,
        receiverId: String(contract?.receiverId),
        senderId: String(contract?.senderId),
        contractAction: EContractActions.ADMIN_DENY_PAYMENT,
      };
      await doAction(body);
      setSnackBarStates(ACTION_UNDER_PROCESSING, "success");
      window.location.reload();
    } catch (error) {
      setSnackBarStates(`${CANNOT_MAKE_THIS_CALL} ${error}`, "error");
      console.log("error", error);
    }
  }, [contract?.id, contract?.receiverId, contract?.senderId, userId]);

  const onConfirm = async (userInput?: string) => {
    if (currentAction) {
      const contractActionBody: IContractActionRequestBody = {
        contractId: contract.id,
        userId: userId,
        actorRole: ESenderRole.ADMIN,
        receiverId: contract?.receiverId,
        senderId: contract.senderId,
        contractAction: currentAction?.action,
        transactionId: userInput,
      };

      try {
        let normalRes;
        if (
          currentAction?.action === actionsMap.settle?.action &&
          (contract.status ===
            ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE ||
            contract.status ===
              ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE) &&
          contract.transactions.some(
            (transaction) =>
              transaction.type === ETrasactionsType.CUSTOMER_PAY &&
              transaction.paymentMethod === "TABBY"
          )
        ) {
          if (userInput) normalRes = await settleTabbyPayment(userInput);
        } else {
          normalRes = await doAction(contractActionBody);

          if (normalRes && normalRes?.sent === true) {
            sendResolveEscalationEvent(
              currentAction.action,
              (contract?.senderRole === ESenderRole.CUSTOMER
                ? contract?.senderId
                : contract?.receiverId) || "",
              contract.shortId,
              (contract?.senderRole === ESenderRole.CUSTOMER
                ? contract?.receiverId
                : contract?.senderId) || ""
            );

            sendRefundReleaseEvent(
              currentAction.action,
              (contract?.senderRole === ESenderRole.CUSTOMER
                ? contract?.senderId
                : contract?.receiverId) || "",
              contract.shortId,
              (contract?.senderRole === ESenderRole.CUSTOMER
                ? contract?.receiverId
                : contract?.senderId) || ""
            );
          }
        }
        doContractAction(normalRes);
      } catch (error) {
        setSnackBarStates(`${CANNOT_MAKE_THIS_CALL} ${error}`, "error");
        doContractAction(undefined);
      }
    }
  };

  const setSnackBarStates = (title: string, color: AlertColor) => {
    setSnackBarOpen(true);
    setSnackBarColor(color);
    setSnackBarTitle(title);
  };
  const renderModal = () => {
    return (
      <DialogModal
        title={CONFIRM}
        open={modalOpen}
        handleClose={async () => {
          closeModal();
        }}>
        <ConfirmContractForm
          contract={contract}
          onConfirm={onConfirm}
          onCancel={closeModal}
          withReferenceInput={withReferenceInput}
          description={currentAction?.description || ""}
        />
      </DialogModal>
    );
  };
  const renderActionsMenu = () => {
    if (isMilestoneContract) return <></>;
    return (
      <Menu
        anchorEl={anchorEl}
        dir="rtl"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id={id}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={!!isMenuOpen}
        onClose={handleMenuClose}>
        {contract.status === ECONTRACT_STATUS.DELIVERY_ESCALATION && (
          <MenuItem onClick={onApproveDeliveryClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>{ACTION_ADMIN_CONFIRM_DELIVERY}</p>
          </MenuItem>
        )}
        {(contract.status === ECONTRACT_STATUS.CREATED ||
          contract.status === ECONTRACT_STATUS.SUBMITTED) && (
          <MenuItem onClick={onDeleteContractClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>{ACTION_ADMIN_DELETE_CONTRACT}</p>
          </MenuItem>
        )}
        {(contract.status === ECONTRACT_STATUS.DELIVERY_ESCALATION ||
          contract.status === ECONTRACT_STATUS.INSPECTION_ESCALATION) && (
          <MenuItem onClick={onResolveRefundBuyerClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>{ACTION_ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER}</p>
          </MenuItem>
        )}
        {(contract.status === ECONTRACT_STATUS.DELIVERY_ESCALATION ||
          contract.status === ECONTRACT_STATUS.INSPECTION_ESCALATION) && (
          <MenuItem onClick={onResolveReleaseSellerClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>{ACTION_ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER}</p>
          </MenuItem>
        )}
        {/* {contract.status === ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER && (
          <MenuItem onClick={onCloseRefundBuyerClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>{ACTION_ADMIN_CLOSE_REFUND_CUSTOMER}</p>
          </MenuItem>
        )} */}
        {/* {contract.status === ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER && (
          <MenuItem onClick={onCloseReleaseSellerClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>
              {isCashoutPending
                ? t("lbl_cashout_already_exists")
                : ACTION_ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER}
            </p>
          </MenuItem>
        )} */}
        {/* {contract.status === ECONTRACT_STATUS.ITEM_ACCEPTED && (
          <MenuItem onClick={onCompleteClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>
              {isCashoutPending
                ? t("lbl_cashout_already_exists")
                : ACTION_ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER}
            </p>
          </MenuItem>
        )} */}
        {(contract.status === ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE ||
          contract.status ===
            ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE) && (
          <MenuItem onClick={onSettleClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>{t("lbl_settle_transaction_title")}</p>
          </MenuItem>
        )}
        {(contract.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY ||
          contract.status === ECONTRACT_STATUS.ITEM_INSPECTION) && (
          <>
            <MenuItem onClick={onResolveReleaseSellerClick}>
              <IconButton size="large" color="inherit">
                <Badge>
                  <EditIcon />
                </Badge>
              </IconButton>
              <p>{RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION}</p>
            </MenuItem>
          </>
        )}
        {contract.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY && (
          <>
            <MenuItem onClick={onResolveRefundBuyerClick}>
              <IconButton size="large" color="inherit">
                <Badge>
                  <EditIcon />
                </Badge>
              </IconButton>
              <p>{CLOSE_WAITING_FOR_DELIVERY}</p>
            </MenuItem>
            <MenuItem onClick={onApproveDeliveryClick}>
              <IconButton size="large" color="inherit">
                <Badge>
                  <EditIcon />
                </Badge>
              </IconButton>
              <p>{CONFIRM_DELIVERY}</p>
            </MenuItem>
          </>
        )}
        {contract.status === ECONTRACT_STATUS.ITEM_INSPECTION && (
          <>
            <MenuItem onClick={onAcceptInspection}>
              <IconButton size="large" color="inherit">
                <Badge>
                  <EditIcon />
                </Badge>
              </IconButton>
              <p>{CONFIRM_INSPECTION}</p>
            </MenuItem>
          </>
        )}
      </Menu>
    );
  };
  const renderSnackBar = () => {
    return snackBarOpen ? (
      <CustomizedSnackbars
        open={snackBarOpen}
        title={snackBarTitle}
        type={snackBarColor}
      />
    ) : null;
  };

  const renderActionsButton = () => {
    if (!isMilestoneContract) return <></>;
    return (
      <div className={styles["button_container"]}>
        {/* {contract?.status === ECONTRACT_STATUS.DELIVERY_ESCALATION && (
          <PrimaryButton onClick={onApproveDeliveryClick}>
            {ACTION_ADMIN_CONFIRM_DELIVERY}
          </PrimaryButton>
        )} */}
        {contract?.status === ECONTRACT_STATUS.DELIVERY_ESCALATION &&
          receiverType === ESenderRole.CUSTOMER && (
            <PrimaryButton onClick={onResolveRefundBuyerClick}>
              {ACTION_ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER}
            </PrimaryButton>
          )}
        {contract?.status === ECONTRACT_STATUS.DELIVERY_ESCALATION &&
          receiverType === ESenderRole.PROVIDER && (
            <PrimaryButton onClick={onResolveReleaseSellerClick}>
              {ACTION_ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER}
            </PrimaryButton>
          )}
        {(contract?.status === ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER ||
          contract?.status === ECONTRACT_STATUS.PARTIALLY_REFUNDED) &&
          receiverType === ESenderRole.CUSTOMER && (
            <PrimaryButton onClick={onCloseRefundBuyerClick}>
              {ACTION_ADMIN_CLOSE_REFUND_CUSTOMER}
            </PrimaryButton>
          )}
        {(contract?.status === ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER ||
          contract?.status === ECONTRACT_STATUS.PARTIALLY_RESOLVE_RELEASED) &&
          receiverType === ESenderRole.PROVIDER && (
            <PrimaryButton
              onClick={onCloseReleaseSellerClick}
              buttonType={
                (isCashoutPending
                  ? ButtonType.DISABLED
                  : ButtonType.DEFAULT) as unknown as PrimaryButtonType
              }>
              {isCashoutPending
                ? t("lbl_cashout_already_exists")
                : ACTION_ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER}
            </PrimaryButton>
          )}
        {(contract?.status === ECONTRACT_STATUS.ITEM_ACCEPTED ||
          contract?.status === ECONTRACT_STATUS.PARTIALLY_RELEASED) &&
          (receiverType === ESenderRole.PROVIDER ||
            receiverType === ESenderRole.BROKER) && (
            <PrimaryButton
              onClick={onCompleteClick}
              buttonType={
                (isCashoutPending
                  ? ButtonType.DISABLED
                  : ButtonType.DEFAULT) as unknown as PrimaryButtonType
              }>
              {isCashoutPending
                ? t("lbl_cashout_already_exists")
                : t("lbl_release")}
            </PrimaryButton>
          )}
        {(contract?.status === ECONTRACT_STATUS.PARTIALLY_PAID ||
          contract?.status === ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION) &&
          receiverType === ESenderRole.CUSTOMER && (
            <div className={styles["transfer_options_container"]}>
              <PrimaryButton
                backgroundColor={"#44C16E"}
                onClick={acceptPayment}>
                {t("lbl_accept_payment")}
              </PrimaryButton>
              <PrimaryButton
                buttonType={PrimaryButtonType.DANGER}
                onClick={rejectPayment}>
                {t("lbl_reject_payment")}
              </PrimaryButton>
            </div>
          )}
        {/* {contract?.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY && (
          <PrimaryButton onClick={onResolveReleaseSellerClick}>
            {RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION}
          </PrimaryButton>
        )}
        {contract?.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY && (
          <PrimaryButton onClick={onResolveRefundBuyerClick}>
            {CLOSE_WAITING_FOR_DELIVERY}
          </PrimaryButton>
        )} */}
        {/* {contract?.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY && (
          <PrimaryButton onClick={onApproveDeliveryClick}>
            {CONFIRM_DELIVERY}
          </PrimaryButton>
        )} */}
      </div>
    );
  };

  return (
    <>
      {renderSnackBar()}
      {renderModal()}
      {renderActionsMenu()}
      {renderActionsButton()}
    </>
  );
};

export default React.memo(ContractActions);
